import React from 'react';
import styles from './BookingFormStepper.module.css';

export default class DeliveryTrackingStepper extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {        
            
        let complete = this.props.job_status === "Delivered";

        return (
            <div styleName="styles.stepper">
                <div styleName={"styles.step" + (this.props.booked || complete ? " styles.step-ok" : "")}>
                    Booked
                    <div styleName="styles.step-icon"></div>
                    <span className="glyphicon glyphicon-ok"></span>
                </div>
                <div styleName="styles.step-divider"></div>
                <div styleName={"styles.step" + (this.props.in_progress || complete  ? " styles.step-ok" : "")}>
                    In Progress
                    <div styleName="styles.step-icon"></div>
                    <span className="glyphicon glyphicon-ok"></span>
                </div>
                <div styleName="styles.step-divider"></div>
                <div styleName={"styles.step" + (this.props.picked_up || complete  ? " styles.step-ok" : "")}>
                    Picked Up
                    <div styleName="styles.step-icon"></div>
                    <span className="glyphicon glyphicon-ok"></span></div>
                <div styleName="styles.step-divider"></div>
                <div styleName={"styles.step" + (this.props.is_enroute || complete  ? " styles.step-ok" : "")}>
                    Enroute
                    <div styleName="styles.step-icon"></div>
                    <span className="glyphicon glyphicon-ok"></span>
                </div>
                <div styleName="styles.step-divider"></div>
                <div styleName={"styles.step" + (this.props.delivered || complete  ? " styles.step-ok" : "")}>
                    Delivered
                    <div styleName="styles.step-icon"></div>
                    <span className="glyphicon glyphicon-ok"></span>
                </div>
            </div>
        )
    }
}